import { Component, OnInit } from '@angular/core';
import { URL_DOCS } from 'src/app/config/config';

import { UsuarioService } from 'src/app/services/usuario.service';
import { GeneralService } from 'src/app/services/general.service';
import { FichaMedicaService } from 'src/app/services/ficha-medica.service';
import { ZoomService } from 'src/app/services/zoom.service';
import { EncriptacionService } from 'src/app/services/encriptacion.service';

import { FormBuilder } from '@angular/forms';

import Swal from 'sweetalert2';

import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-busca-historial-consulta',
  templateUrl: './busca-historial-consulta.component.html',
  styleUrls: [
    '../../../../assets/css/styles.css',
    './busca-historial-consulta.component.css'
  ]
})
export class BuscaHistorialConsultaComponent implements OnInit {

  usuario: any = {};

  toDay: any = {};

  options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  options_week = {
    weekday: 'long'
  };

  options_month = {
    month: 'long'
  };

  appointments: any[] = [];
  appointmentsToDay: any[] = [];
  appointmentsPast: any[] = [];

  appointment_selected: any = {};

  URL_DOCUMENTS = URL_DOCS;

  ficha_eventos = false;

  consulta_selected: any = {};

  usuario_buscado: any = {};

  steps = [true, false];

  rutCuenta: string;
  tipo_usuario_name: string;

  rutBuscar: string;

  public muestraPerfil = true;
  public noHayInfo = true;
  public esmedico = false;

  rut = '';
  tipo_de_usuario: string;

  beneficiarios_data: any[] = [];

  beneficiario_selected: any;

  mostrarSugerencias = false;
  buscandoBeneficiarios = false;

  private ultimaBusqueda = '';
  private requestId = 0;

  public rutABuscar = this.fb.group({
    rutBuscarPlataforma: ['']
  });

  constructor(
    public _usuarioService: UsuarioService,
    public _general: GeneralService,
    private _fichaMedicaServices: FichaMedicaService,
    private _zoomService: ZoomService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {

    this.usuario = new EncriptacionService().getUserInfo();

    this.rutCuenta = this.usuario.rut;
    this.tipo_usuario_name = this.usuario.typ_name;

    this.toDay.date = new Date();

    this.toDay.dateInt =
      this.toDay.date.getFullYear() * 10000 +
      (this.toDay.date.getMonth() + 1) * 100 +
      this.toDay.date.getDate();

    this.toDay.dateString =
      this.toDay.date.toLocaleString('es-US', this.options);

    this.toDay.dayTitle =
      this.toDay.date.getDate() +
      ' de ' +
      this.toDay.date.toLocaleString('es-US', this.options_month);

    this.rutABuscar
      .get('rutBuscarPlataforma')
      .valueChanges
      .pipe(
        debounceTime(500),
        map((valor: string) => valor ? valor.trim() : ''),
        distinctUntilChanged()
      )
      .subscribe((valor: string) => {

        this.beneficiario_selected = null;

        if (!valor || valor.length < 3) {
          this.limpiarBeneficiarios();
          return;
        }

        if (valor === this.ultimaBusqueda) {
          return;
        }

        this.ultimaBusqueda = valor;

        this.getBeneficiarios(valor);
      });
  }

  getBeneficiarios(valor: string) {

    const currentRequestId = ++this.requestId;

    this.buscandoBeneficiarios = true;
    this.mostrarSugerencias = true;

    this._general.postListarusuariosSistema(valor)
      .then((results: any[]) => {

        if (currentRequestId !== this.requestId) {
          return;
        }

        this.beneficiarios_data = results || [];

        this.beneficiarios_data.forEach(ben => {

          ben.nombre_completo =
            `${ben.use_name || ''} ` +
            `${ben.use_paternal_surname || ''} ` +
            `${ben.use_maternal_surname || ''} : ` +
            `${ben.use_username || ''}`;

        });

        this.buscandoBeneficiarios = false;
        this.mostrarSugerencias = true;

      })
      .catch(error => {

        this.buscandoBeneficiarios = false;

        this.limpiarBeneficiarios();

        Swal.fire({
          icon: 'warning',
          title: 'Error al cargar los beneficiarios.',
          timer: 2000
        });

      });
  }

  seleccionarBeneficiario(ben: any) {

    this.beneficiario_selected = ben;

    this.mostrarSugerencias = false;

    this.rutABuscar
      .get('rutBuscarPlataforma')
      .setValue(ben.nombre_completo, {
        emitEvent: false
      });
  }

  limpiarBeneficiarios() {

    this.beneficiarios_data = [];

    this.mostrarSugerencias = false;

    this.buscandoBeneficiarios = false;

    this.beneficiario_selected = null;
  }

  buscarRut() {

    if (!this.beneficiario_selected || !this.beneficiario_selected.use_username) {

      this._general.modalError(
        'Debe seleccionar un usuario válido desde el listado.',
        'Usuario no seleccionado'
      );

      return;
    }

    this.rutBuscar = this.beneficiario_selected.use_username;

    this.usuario_buscado = {};

    this.appointments = [];
    this.appointmentsToDay = [];
    this.appointmentsPast = [];

    const buscarSinPuntos = this.rutBuscar.split('.').join('');

    if (!this._general.validaRut(buscarSinPuntos)) {

      this._general.modalError(
        'El usuario buscado no existe en el sistema',
        'Ingresar rut válido'
      );

      return;
    }

    this._fichaMedicaServices.getListarConsultasPasadas({
      paciente: buscarSinPuntos,
      doc_id: null,
      date: null
    })
      .then((result: any) => {

        if (!(result.consultas.length > 0)) {
          return;
        }

        const consultas = result.consultas;

        for (const appt of consultas) {

          const hour = appt.hora.substr(0, 2);
          const minute = appt.hora.substr(3, 2);

          const apptDate = new Date(
            appt.fecha_consulta.substr(0, 10).replaceAll('-', '/')
          );

          apptDate.setHours(hour);
          apptDate.setMinutes(minute);

          const now = new Date();

          const formatedApptDate = this.formatApptDate(apptDate, now);

          if (formatedApptDate.length > 0) {

            let confirmFlag = false;

            const msToAppt = this.timeToX(apptDate, now);

            const minToAppt = this.msToMin(msToAppt);

            if (
              appt.tel_doc_app_boo_sta_id === 10 &&
              minToAppt <= 2880
            ) {
              confirmFlag = true;
            }

            let goLobbyFlag = false;

            if (minToAppt <= 60) {
              goLobbyFlag = true;
            }

            const apptData = {
              date: formatedApptDate,
              doctorName: appt.nombre_doctor.split(' ', 1)[0],
              doctorLastName: appt.apellido_paterno_doctor,
              spec: appt.spe_name,
              subSpec: appt.sub_spe_name,
              img: appt.img ? appt.img : '',
              confirmFlag,
              confirmedFlag: appt.tel_doc_app_boo_sta_id === 30,
              goLobbyFlag,
              id_consulta: appt.id_consulta,
              zoo_mee_room_id: appt.zoo_mee_room_id,
              med_con_id: appt.med_con_id,
              consulta: appt,
              tel_doc_app_boo_is_ondemand: appt.tel_doc_app_boo_is_ondemand,
              sta_name: appt.sta_name,
              nombre_paciente: appt.nombre_paciente,
              apellido_paterno_paciente: appt.apellido_paterno_paciente,
              motivo_cancelacion_videollamada: (appt.motivo_cancelacion_videollamada) ? appt.motivo_cancelacion_videollamada : '-'
            };

            this.appointments.push(apptData);

            const apptDateInt =
              apptDate.getFullYear() * 10000 +
              (apptDate.getMonth() + 1) * 100 +
              apptDate.getDate();

            if (this.toDay.dateInt === apptDateInt) {
              this.appointmentsToDay.push(apptData);
            } else {
              this.appointmentsPast.push(apptData);
            }
          }
        }
      })
      .catch(e => console.log(e));
  }

  formatApptDate = (apptDate: Date, now: Date) => {

    const months = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre'
    ];

    const month = months[apptDate.getMonth()];

    const returnDate: string[] = [
      `${apptDate.getDate()} de ${month}`,
      ''
    ];

    const auxApptDateHour = apptDate.getHours();
    const auxApptDateMin = apptDate.getMinutes();

    const auxApptFormHour =
      `${auxApptDateHour < 10 ? '0' + auxApptDateHour : auxApptDateHour}`;

    const auxApptFormMin =
      `${auxApptDateMin < 10 ? '0' + auxApptDateMin : auxApptDateMin}`;

    returnDate[1] =
      `a las ${auxApptFormHour}:${auxApptFormMin} horas`;

    return returnDate;
  }

  timeToX = (someDate: Date, now: Date) =>
    someDate.getTime() - now.getTime();

  msToMin = (ms: number) =>
    Math.floor(ms / 60000);

  isToday = (apptDate: Date, now: Date): boolean => {

    return (
      apptDate.getFullYear() === now.getFullYear() &&
      apptDate.getMonth() === now.getMonth() &&
      apptDate.getDate() === now.getDate()
    );
  }

  obtenerConsulta(boo_id) {

    this.steps = [false, true];

    this._zoomService.getConsulta(boo_id)
      .then(resultado => {

        this.consulta_selected = resultado;

        this.ficha_eventos = true;

      })
      .catch(error => {
        console.log(error);
      });
  }

  verDetalle(consulta_detalle) {

    this.appointment_selected = consulta_detalle;

    this.obtenerConsulta(consulta_detalle.id_consulta);
  }

  checkStep() {

    this.steps = [true, false];

    this.ficha_eventos = false;
  }

}